import axios from '@/api/axios'
import { useUsersStore } from './user'
import { useSwal } from '@/composables'
import { extractClapError } from '@/helpers/errorHelper'

export const useSubscriptionStore = defineStore('subscription', {
  state: () => ({
    allSubscriptions: [] as any[],
    count: 0,
  }),

  getters: {
    subscriptions: state => state.allSubscriptions,

    currentSubscription(state) {
      if (!state.allSubscriptions.length) return null
      const userStore = useUsersStore()
      const userId = state.allSubscriptions[0].user
      const user = userStore.userById(userId)
      if (!user) return null

      if (user.role === 2) {
        return state.allSubscriptions.find(
          sub =>
            sub.type === 'times' && !!sub.usagesLeft && !sub.expiredFromAdmin
        )
      }
      return null
    },

    // subscriptionsHistory(state) {
    //   const current = this.currentSubscription
    //   if (!current) return state.subscriptions
    //   return state.subscriptions.filter(sub => sub._id !== current._id)
    // },
  },

  actions: {
    async getSubscriptions({
      page = 1,
      perPage = 25,
      user = '',
      sortBy = '',
      sortDesc = '',
    } = {}) {
      try {
        // const params = new URLSearchParams({
        //   page: page.toString(),
        //   perPage: perPage.toString(),
        //   user,
        //   sortBy,
        //   sortDesc: sortDesc.toString(),
        // })
        const { data } = await axios.get(
          `/subscription/type?
          `
          // ${params.toString()}
        )
        this.allSubscriptions = data
        // this.count = data.count
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },

    async updateSubscription(payload: any) {
      try {
        await axios.put(`/subscription/type/${payload._id}`, payload)
        this.allSubscriptions = this.allSubscriptions.map(sub =>
          sub._id === payload._id ? payload : sub
        )
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },

    async createSubscription(payload: any) {
      try {
        const { data } = await axios.post('/subscription/type', payload)
        if (!payload.partner) this.allSubscriptions.push(data)
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },

    async deleteSubscription(id: string) {
      try {
        await axios.delete(`/subscription/type/${id}`)
        this.allSubscriptions = this.allSubscriptions.filter(t => t._id !== id)
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },
  },
})
